import { FC } from "react";
import styled from "styled-components";

import Text from "@/components/Text";
import { ReleaseResource } from "@/types/resources";
import DistributionRepostInformation from "./DistributionRepostInformation";

const Headline = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 24px;
  background: #fdfdfd;
  border-top: 0.5px solid ${({ theme }) => theme.colors.lightGray};
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.lightGray};
  margin: 0 -24px;
`;

const CounterBadge = styled(Text)`
  background: ${({ theme }) => theme.colors.purpleLighter};
  border-radius: 50%;
  margin-left: 8px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Reposts = styled.div`
  margin-top: 16px;
`;

interface Props {
  reposts: ReleaseResource[];
}

const DistributionListItemConditions: FC<Props> = ({ reposts }) => {
  return (
    <Reposts>
      <Headline>
        <Text as="span" $type="smallBold" $color="purpleLighter">
          Conditional reposts
        </Text>
        <CounterBadge $color="grayscaleLight" $type="extraSmall" as="span">
          {reposts.length}
        </CounterBadge>
      </Headline>
      {reposts.map((repost, index) => (
        <DistributionRepostInformation
          key={repost.id}
          repost={repost}
          index={index}
        />
      ))}
    </Reposts>
  );
};

export default DistributionListItemConditions;
